import $ from 'jquery';

$(document).ready(function() {
    $('.course-accordion__toggle').click(function(e){
        e.preventDefault();
        let $item = $(this).parent();
        $item.toggleClass('course-accordion__item--expanded');
    });
});
